import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';

export function DialogCaption({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={twMerge(
        'flex items-start justify-start text-theme-solid-60 font-small2 py-4pxr',
        className
      )}
      {...props}
    >
      <Text className="mr-4pxr">·</Text>
      <Text>{children}</Text>
    </div>
  );
}

export const DialogCaptionType = (<DialogCaption />).type;
